/**
 * FG Read More. Progressive-enhancement show-more for prose / rich-text content.
 *
 * Without JS the full content renders (no truncation). On connect, if the content
 * is taller than its collapsed height, it clamps the content and reveals a
 * Read more / Read less toggle. Content-agnostic, no theme dependencies.
 *
 * Markup:
 *   <fg-read-more style="--fg-rm-collapsed: 160px;">
 *     <div data-fg-rm-content> ...rich text... </div>
 *     <button data-fg-rm-toggle hidden aria-expanded="false">...</button>
 *   </fg-read-more>
 */
class FgReadMore extends HTMLElement {
  connectedCallback() {
    const content = this.querySelector('[data-fg-rm-content]');
    const toggle = this.querySelector('[data-fg-rm-toggle]');
    if (!content || !toggle) return;

    const collapsed = parseInt(getComputedStyle(this).getPropertyValue('--fg-rm-collapsed'), 10) || 160;

    requestAnimationFrame(() => {
      // Fits within the collapsed height: leave it fully visible, no toggle.
      if (content.scrollHeight <= collapsed + 4) return;

      this.dataset.state = 'collapsed';
      toggle.hidden = false;
      toggle.addEventListener('click', () => {
        const isCollapsed = this.dataset.state === 'collapsed';
        this.dataset.state = isCollapsed ? 'expanded' : 'collapsed';
        toggle.setAttribute('aria-expanded', String(isCollapsed));
      });
    });
  }
}

if (!customElements.get('fg-read-more')) {
  customElements.define('fg-read-more', FgReadMore);
}
